import React from 'react';
import { CONTENT_MAX_WIDTH } from '../constants';
import { useShareModal } from '../hooks/useShareModal';

export const Navigation = () => {
  const [shareModal] = useShareModal();

  return (
    <>
      {shareModal}
      <div
        className="nav-container"
        style={{
          padding: '15px 20px',
          backgroundColor: 'white',
          position: 'sticky',
          top: 0,
          zIndex: 100,
        }}
      >
        <div
          style={{
            margin: 'auto',
            maxWidth: CONTENT_MAX_WIDTH,
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'row',
            justifyContent: 'space-between',
          }}
        >
          <a
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              gap: 12,
              padding: 0,
              color: '#1a1a1a',
              textDecoration: 'none',
            }}
            href={window.location.pathname === '/' ? '#' : '/'}
          >
            {/* <img
              height="32"
              width="32"
              src="/logo.png"
              alt="CardClues logo"
              style={{ borderRadius: '4px' }}
            /> */}
            <h2
              style={{
                margin: 0,
                fontWeight: 300,
                fontSize: 20,
              }}
            >
              CardClues
            </h2>
          </a>
          <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
            <a
              href="/browse-wallets"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: '#1a1a1a',
                textDecoration: 'none',
                fontSize: '14px',
                fontWeight: 400,
              }}
            >
              Wallets
            </a>
          </div>
        </div>
        <style>
          {`
            @media (max-width: 768px) {
              .nav-container {
                padding: 12px 16px;
              }
            }
          `}
        </style>
      </div>
    </>
  );
};
